import initStations from './initStations';
import setActionFilter from './setActionFilter';
import getStations from './getStations';
import resetFilter from './resetFilter';
import setStationsFitBounds from './setStationsFitBounds';
import setFilter from './setFilter';
import resetFilterStatusLoading from './resetFilterStatusLoading';
import updateAllStations from './updateAllStations';
import setRouteFilter from './setRouteFilter';
import resetRouteFilter from './resetRouteFilter';
import setStations from './setStations';
import setAllStationsLoadingStatus from './setAllStationsLoadingStatus';
import setRestrictions from './setRestrictions';

const operations = {
  initStations,
  getStations,
  setActionFilter,
  setFilter,
  resetFilter,
  setStationsFitBounds,
  resetFilterStatusLoading,
  updateAllStations,
  setRouteFilter,
  resetRouteFilter,
  setStations,
  setAllStationsLoadingStatus,
  setRestrictions,
};

export default operations;
